import { onMounted, onUnmounted, ref } from 'vue'

// Named function references (not inline arrows passed separately to add/removeEventListener)
// are what make the onUnmounted cleanup below actually work: removeEventListener only
// detaches a listener that is === (by reference) the one addEventListener received. A
// composable used from a component mounted on every route (e.g. OfflineBanner) that got
// this wrong would leak one `online`/`offline` listener on `window` per navigation.
export function useOnline() {
  const online = ref(globalThis.navigator?.onLine ?? true)

  function update() {
    online.value = globalThis.navigator?.onLine ?? true
  }

  onMounted(() => {
    window.addEventListener('online', update)
    window.addEventListener('offline', update)
  })

  onUnmounted(() => {
    window.removeEventListener('online', update)
    window.removeEventListener('offline', update)
  })

  return { online }
}
